import React from 'react'
import { SvgIcon } from '@mui/material'

export const ReplaceIcon = props => (
  <SvgIcon viewBox="0 0 20 20" sx={{ color: 'secondary.main' }} {...props}>
    <path
      d="M15.83 6.67 12.5 10H15a5 5 0 0 1-7.33 4.42l-1.22 1.21A6.66 6.66 0 0 0 16.67 10h2.5l-3.34-3.33ZM5 10a5 5 0 0 1 7.33-4.42l1.22-1.21A6.66 6.66 0 0 0 3.33 10H.83l3.34 3.33L7.5 10H5Z"
      fill="#55A6FF"
    />
  </SvgIcon>
)
